(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // existing hash scroll code...
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Price scaling
  function scalePrices() {
    const grid = document.querySelector('ul.product-grid');
    if (!grid) return;
    const firstCard = grid.querySelector('li');
    if (!firstCard) return;
    const cols = Math.round(grid.offsetWidth / firstCard.offsetWidth);

    if (cols <= 2) {
      document.querySelectorAll('product-price').forEach(el => el.style.removeProperty('--font-size'));
      return;
    }

    document.querySelectorAll('product-price').forEach(el => {
      const card = el.closest('li');
      if (!card) return;
      const titleEl = card.querySelector('[class*="product_title"]');
      const titleSize = titleEl ? parseFloat(getComputedStyle(titleEl).fontSize) : 16;
      el.style.setProperty('--font-size', (titleSize * 0.85) + 'px');
    });
  }

  const gridObserver = new ResizeObserver(() => scalePrices());
  const mutationObserver = new MutationObserver(() => {
    const grid = document.querySelector('ul.product-grid');
    if (grid) {
      gridObserver.observe(grid);
      scalePrices();
    }
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', scalePrices);

  } catch(e) { console.error(e); }
})();
})();
